// extracted by mini-css-extract-plugin
export default {"mandatory":"App_mandatory__P3fqQ","navButtonContainer":"App_navButtonContainer__DneTv","contactText":"App_contactText__-7pxv"};